(function (window) {
    "use strict";
    function defineRoleHelper() {
        let roleHelper = {};
        roleHelper.role = {
            admin: 1,
            userType1: 2,
            userType2: 3,
            specialUser: 4
        };
        return roleHelper;
    }
    //define globally if it doesn't already exist
    if (typeof (roleHelper) === "undefined") {
        window.roleHelper = defineRoleHelper();
    } else {
        console.log("roleHelper already defined.");
    }
})(window);